<template>
  <div class="main lh-15 c-666">
    <div class="basestation-banner">
      <ProductBanner
        :banner-img="bannerImg"
        :product-name="$t('common.productName.basestation')"
        :main-title="$t('products.basestation.bannerTitle')"
        :sub-title="$t('products.basestation.bannerSubTitle')"
        :product-img-style="bannerSmallImg"
      >
      </ProductBanner>
    </div>
    <!-- banner:end -->
    <div class="content p-r z-3 bgc-fff">
      <NavAnchor :product-name="$t('common.productName.basestation')" />
      <!-- nav-anchor:end -->
      <div class="area-1 bgc-fafafa" id="overview">
        <div class="w-12r m-a" v-html="area1Data.desc"></div>
        <IconWrap :icon-wrap-data="area1Data.iconWrapData" />
      </div>
      <!-- area-1:end -->
      <div class="area-2">
        <ImgDesc :is-reverse="1" :is-re="false" :img-desc-data="area2Data" />
      </div>
      <!-- area-2:end -->
      <div class="area-3">
        <ImgDesc :img-desc-data="area3Data.imgData">
          <template v-for="(item, index) in area3Data.textData">
            <strong :key="Math.random(index)" class="d-b reveal">{{ item.title }}</strong>
            <div :key="Math.random(index)" class="desc reveal" v-html="item.desc"></div>
          </template>
        </ImgDesc>
      </div>
      <!-- area-3 -->
      <div class="area-4">
        <ImgDesc :is-reverse="1" :img-desc-data="area4Data.imgData">
          <template v-for="(item, index) in area4Data.textData">
            <strong :key="Math.random(index)" class="d-b reveal">{{ item.title }}</strong>
            <div :key="Math.random(index)" class="desc reveal" v-html="item.desc"></div>
          </template>
        </ImgDesc>
      </div>
      <!-- area-4:end -->
      <div class="area-5 bgc-fafafa">
        <div class="w-12r m-a p-r">
          <div class="text-wrapper p-a reveal">
            <h3 class="c-333">{{ area5Data.title }}</h3>
            <div v-html="area5Data.desc"></div>
          </div>
          <div class="img-wrapper p-a">
            <img :src="area5Data.imgSrc" width="100%" height="100%" alt="Removable Battery" />
            <i class="d-b p-a">
              <svg-icon icon-class="basestation-line"></svg-icon>
            </i>
          </div>
        </div>
      </div>
      <!-- area-5:end -->
      <div class="area-6">
        <ImgDesc :is-reverse="1" :main-title="area6Data.mainTitle" :img-desc-data="area6Data.modList" />
      </div>
      <!-- area-6:end -->
      <section class="area-specs w-12r m-a" id="features">
        <h2 class="fs-48 ta-c c-333 mb-32">{{ areaSpecs.title }}</h2>
        <table>
          <tr v-for="(item, index) in areaSpecs.tableList" :key="index">
            <template v-if="item.length === 2">
              <td v-html="item[0]"></td>
              <td v-html="item[1]"></td>
            </template>
            <template v-else>
              <td colspan="2" class="sub-title" v-html="item[0]"></td>
            </template>
          </tr>
        </table>
      </section>
    </div>
    <!-- content:end -->
  </div>
</template>

<script>
  import bannerPic from '@/assets/images/basestation/banner_pic.png'
  import bannerScroll from '@/mixins/bannerScroll.js'

  import ProductBanner from '@/components/ProductBanner'
  import NavAnchor from '@/components/NavAnchor'
  import IconWrap from '@/components/IconWrap'
  import ImgDesc from '@/components/ImgDesc'

  export default {
    components: {
      ProductBanner,
      NavAnchor,
      IconWrap,
      ImgDesc
    },
    mixins: [bannerScroll],
    data() {
      return {
        bannerImg: require('@/assets/images/basestation/banner.jpg'),
        bannerSmallImg: { 'background-image': `url(${bannerPic})`, width: '5.98rem', height: '3.1rem' },
        area1Data: {
          desc: this.$t('products.basestation.area1Text'),
          iconWrapData: [
            {
              icon: 'basestation-area1-icon1',
              vHtml: this.$t('products.basestation.area1Icon01Text')
            },
            {
              icon: 'basestation-area1-icon2',
              vHtml: this.$t('products.basestation.area1Icon02Text')
            },
            {
              icon: 'basestation-area1-icon3',
              vHtml: this.$t('products.basestation.area1Icon03Text')
            },
            {
              icon: 'basestation-area1-icon4',
              vHtml: this.$t('products.basestation.area1Icon04Text')
            },
            {
              icon: 'basestation-area1-icon5',
              vHtml: this.$t('products.basestation.area1Icon05Text')
            },
            {
              icon: 'basestation-area1-icon6',
              vHtml: this.$t('products.basestation.area1Icon06Text')
            }
          ]
        },
        area2Data: [
          {
            imgSrc: require('@/assets/images/basestation/area_2.png'),
            title: this.$t('products.basestation.area2Title'),
            desc: this.$t('products.basestation.area2Desc')
          }
        ],
        area3Data: {
          imgData: [
            {
              imgSrc: require('@/assets/images/basestation/area_3.png')
            }
          ],
          textData: [
            {
              title: this.$t('products.basestation.area3Title01'),
              desc: this.$t('products.basestation.area3Desc01')
            },
            {
              title: this.$t('products.basestation.area3Title02'),
              desc: this.$t('products.basestation.area3Desc02')
            }
          ]
        },
        area4Data: {
          imgData: [
            {
              imgSrc: require('@/assets/images/basestation/area_4.png')
            }
          ],
          textData: [
            {
              title: this.$t('products.basestation.area4Title01'),
              desc: this.$t('products.basestation.area4Desc01')
            },
            {
              title: this.$t('products.basestation.area4Title02'),
              desc: this.$t('products.basestation.area4Desc02')
            }
          ]
        },
        area5Data: {
          title: this.$t('products.basestation.area5Title'),
          desc: this.$t('products.basestation.area5Desc'),
          imgSrc: require('@/assets/images/basestation/area_5.png')
        },
        area6Data: {
          mainTitle: this.$t('products.basestation.area6Title'),
          modList: [
            {
              imgSrc: require('@/assets/images/basestation/area_6_1.jpg'),
              title: this.$t('products.basestation.area6SubTitle01'),
              desc: this.$t('products.basestation.area6SubDesc01'),
              link: '/product/autosteeringkit',
              icon: 'arr-icon'
            },
            {
              imgSrc: require('@/assets/images/basestation/area_6_2.jpg'),
              title: this.$t('products.basestation.area6SubTitle02'),
              desc: this.$t('products.basestation.area6SubDesc02'),
              link: '/product/excavatorguidance',
              icon: 'arr-icon'
            }
          ]
        },
        areaSpecs: {
          title: this.$t('products.basestation.areaSpecsTitle'),
          tableList: this.$t('products.basestation.areaSpecsTable')
        }
      }
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  :deep(.basestation-banner .banner-title span) {
    margin-bottom: 0;
  }
  :deep(.basestation-banner .banner-title i) {
    font-size: 0.64rem;
    font-weight: 700;
  }
  .area-1 {
    padding-top: 1.6rem;
    padding-bottom: 1rem;
  }
  .area-2 {
    padding-top: 1.6rem;
  }
  :deep(.area-2 .img-desc .text),
  :deep(.area-3 .img-desc .text),
  :deep(.area-4 .img-desc .text) {
    background-color: transparent;
  }
  :deep(.area-2 .img-desc .img-box) {
    width: 6.5rem;
    height: auto;
  }
  :deep(.area-3 .img-desc .img-box) {
    width: 6.5rem;
    height: auto;
  }
  .area-3 .img-desc .text .desc,
  .area-4 .img-desc .text .desc {
    margin-bottom: 0.48rem;
  }
  :deep(.area-4 .img-desc .img-box) {
    width: 7rem;
    height: auto;
    margin-right: 0.6rem;
  }
  :deep(.area-4 .img-desc .text) {
    width: auto;
  }
  .area-5 {
    & > div {
      height: 7.5rem;
    }
    h3 {
      margin-bottom: 0.24rem;
      font-size: 0.32rem;
    }
    .img-wrapper {
      width: 7.91rem;
      height: 5rem;
      right: -1.5rem;
      top: 0.5rem;
      i {
        width: 3rem;
        height: auto;
        top: 2.7rem;
        left: -0.3rem;
      }
    }
    .text-wrapper {
      left: 0.5rem;
      top: 3.5rem;
    }
  }
  .area-6 {
    padding-top: 1.6rem;
  }
  .area-specs {
    padding-bottom: 1.6rem;
    table {
      width: 100%;
      td {
        border: 1px solid #d2d2d2;
        padding: 10px 20px;
        &:nth-child(2n + 1) {
          background: #f8f9fb;
          color: #333;
          font-weight: 700;
        }
      }
      .sub-title {
        font-size: 0.28rem;
      }
    }
  }
</style>
